import { Button, Skeleton } from '@bbl-digital/snorre'
import { FC, ReactNode, type JSX } from 'react'
import { Wrapper } from './styles'

interface IProps {
  length?: number
}

// Loader for FileInput
const SkeletonFileInput: FC<IProps> = ({ length = 0 }) => {
  const list: JSX.Element | ReactNode[] = []

  for (let i = 0; i < length; i++) {
    list.push(<Skeleton key={i} height="32px" width="100%" />)
  }

  return (
    <Wrapper>
      {list.length > 0 && list}
      <Button loading outline>
        {' '}
      </Button>
    </Wrapper>
  )
}

export default SkeletonFileInput
